<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">IdMenu</th>
                <th :class="StyleTh">Nombre</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><p :class="StyleTd">{{lista.IdMenu}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>

					<td class="align-middle text-end">
                       <button v-if="lista.Agregar" @click="AgregarModuloSistema(lista)" class="btn btn-link text-primary px-3 mb-0 mr-1" type="button"><i aria-hidden="true" class="fas fa-check-circle text-primary me-2"></i>Agregar</button>
                       <button @click="VerModuloSistemaDetalle(lista.IdModuloSistema)" class="btn btn-link text-secondary px-3 mb-0 mr-1" type="button"><i aria-hidden="true" class="fas fa-eye text-secondary me-2"></i>Ver Detalles</button>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="4"></CSinRegistros>
			</template>
		</CList>
        <CModal :pConfigModal="ConfigModal">
            <template slot="Form">
                <div class="card">
                    <div class="card-body">
                        <div class="table-responsive">
                            <CLoader :pConfigLoad="ConfigLoadDetallesModuloSistema">
                                <template slot="BodyFormLoad">
                                    <table class="table align-items-center mb-0">
                                        <thead>
                                            <tr>
                                                <th :class="StyleTh+' text-center'">#</th>
                                                <th :class="StyleTh" width="90%">Nombre</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(lista,index) in ListaModuloDetalle" :key="index">
                                                <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                                <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                            </tr>
                                            <CSinRegistros :pContIF="ListaModuloDetalle.length" :pColspan="6"></CSinRegistros>
                                        </tbody>
                                    </table>
                                </template>
                            </CLoader>
                        </div>
                    </div>
                </div>
            </template>
        </CModal>
	</div>
</template>

<script>
const EmitEjecuta = 'seccionModulosSistema'

import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'ListModulosSitema',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
            ConfigList:{
                TitleFirst: '',
                IsModal: false,
                BtnNewShow:false,
                ShowTitleFirst: false,
                BtnReturnShow: false,
                ShowFooter:false,
                TitleFirst: '',
                ShowTitleEnd:false,
                ShowLoader: true,
                GoRoute:'paquetesSistemaForm',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ListaModuloDetalle:[],
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModal:{
                ModalTitle: "Módulos Sistema Detalle",
                ModalNameId: 'ModalList',
                EmitSeccion: EmitEjecuta,
                ShowFooter: false,
            },  
            ConfigLoadDetallesModuloSistema:{
                ShowLoader: false,
                ClassLoad: false,
            },
            objPaqueteSistema: {
				IdPaqueteSistema: 0,
				Nombre: '',
				Precio: '',
				Vigencia: '',
				Estatus: true,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],           
            ListaModulosAgregados: [],           
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods :
    {
        async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("modulosSistema",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
                this.ListaArrayRows.forEach(elem => {
                    let estaAgregado =  this.ListaModulosAgregados.some(mod => mod.IdModuloSistema == elem.IdModuloSistema)
                    elem['Agregar'] = !estaAgregado;
                })
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        AgregarModuloSistema(item){
            this.bus.$emit('AgregarModuloSistema',item)
        },
        VerModuloSistemaDetalle(idModuloSistema){
            this.bus.$emit('NewModal_'+EmitEjecuta,0,{});
            this.ConfigLoadDetallesModuloSistema.ShowLoader = true;
            this.$http.get(
            "modulosSistema/"+idModuloSistema
            ).then((res) => {
                this.ListaModuloDetalle = res.data.Detalles;
            }).finally(()=>{
                this.ConfigLoadDetallesModuloSistema.ShowLoader = false;
            }).catch(err => console.error(err))
        },
        Limpiar()
        {
            this.objPaqueteSistema = {
				IdPaqueteSistema: 0,
				Nombre: '',
				Precio: '',
				Vigencia: '',
				Estatus: '',
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(ListaModulosAgregados)=>
        {
            this.ListaModulosAgregados = ListaModulosAgregados;
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            this.Limpiar();
            this.Lista();
        });
    }
}
</script>
